var React = require('react');

function Bell (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30,68.571A8.57,8.57,0,0,0,38.567,60H21.433A8.57,8.57,0,0,0,30,68.571Zm28.847-20.05c-2.587-2.78-7.429-6.963-7.429-20.664A21.149,21.149,0,0,0,34.283,7.077V4.286a4.283,4.283,0,1,0-8.566,0V7.077A21.149,21.149,0,0,0,8.582,27.857c0,13.7-4.842,17.883-7.429,20.664A4.184,4.184,0,0,0,0,51.428a4.29,4.29,0,0,0,4.3,4.286H55.7A4.289,4.289,0,0,0,60,51.428a4.182,4.182,0,0,0-1.153-2.908Z","transform":"translate(1.5 1.5)","fill":"none","stroke":"#fff","strokeWidth":"3"}));
}

Bell.defaultProps = {"width":"63","height":"71.571","viewBox":"0 0 63 71.571"};

module.exports = Bell;

Bell.default = Bell;
